<template>
   <footer role="footer" class="footer mt-auto py-3 text-center container">
      <div class="row">
         <div v-if="!trueCenter" class="col-lg-3"></div>
         <div :class="trueCenter ? 'col-lg-12' : 'col-lg-9'">
            <p>
               <span>
                  <a href="https://uptimeinstitute.com/" target="_blank">Uptime Institute</a
                  >&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="https://uptimeinstitute.com/contact" target="_blank">Contact</a
                  >&nbsp;&nbsp;&nbsp; &nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;<a
                     href="https://uptimeinstitute.com/privacy-policy"
                     target="_blank"
                     >Privacy Policy</a
                  >&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="https://uptimeinstitute.com/terms-of-use" target="_blank">Terms of Use</a
                  >&nbsp;&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
                  <a href="/feedback"> Feedback</a>
                  <!--
                  <a href="/resources/#how-to">How to use Career Pathfinder</a>&nbsp;&nbsp;|
                  <a href="/resources/#who-for">Who is this for?</a>&nbsp;&nbsp;|
                  <a href="/resources/#who-works">Who works in the data center sector?</a
                  >&nbsp;&nbsp;|
                  <a href="/resources/#what-is">What is a data center?</a> -->
               </span>
            </p>
            <p>© Uptime Institute, LLC. All Rights Reserved.</p>
            <div class="powered-by" v-if="!homepage">
               <span class="h5"> In collaboration with </span>
               <!--img
                  src="~@/assets/images/uptime-logo.png"
                  alt="Uptime Institute logo"
                  class="logo"
               / -->
               <div>
                  <a href="https://www.google.com/about/datacenters/life" target="_blank">
                     <img
                        src="~@/assets/images/google-sized.svg"
                        alt="Google logo"
                        class="partner-logo"
                  /></a>
                  <a
                     href="https://www.metacareers.com/areas-of-work/infrastructure"
                     target="_blank"
                  >
                     <img
                        src="~@/assets/images/meta-sized.svg"
                        alt="Facebook logo"
                        class="meta-logo"
                  /></a>
                  <a href="https://careers.microsoft.com/us/en/c/data-center-jobs" target="_blank">
                     <img
                        src="~@/assets/images/microsoft-sized.svg"
                        alt="Microsoft logo"
                        class="partner-logo"
                  /></a>
               </div>
            </div>
         </div>
      </div>
   </footer>
</template>

<script>
export default {
   /* eslint-disable vue/require-default-prop, vue/require-prop-types */
   name: 'PageFooter',
   props: ['homepage'],
   computed: {
      trueCenter: function () {
         return this.$route.name !== 'Categories' && this.$route.name !== 'Careers';
      },
   },
   mounted: function () {
      if (this.trueCenter) {
         document.documentElement.classList.add('h-100');
         document.body.classList.add('d-flex', 'flex-column', 'h-100');
         document.getElementById('app').classList.add('d-flex', 'flex-column', 'h-100');
      } else {
         document.documentElement.classList.remove('h-100');
         document.body.classList.remove('d-flex', 'flex-column', 'h-100');
         document.getElementById('app').classList.remove('d-flex', 'flex-column', 'h-100');
      }
   },
};
</script>



// WEBPACK FOOTER //
// src/components/PageFooter.vue